module.exports = __webpack_public_path__ + "img/tb_mixed.aa1aaa21.jpg";